import request from '@/utils/request';

/**
 *  用户信息接口
 * @returns {{getUserInfo: (function(*=): *)}}
 */
export function VipApi () {
  return {
    //vip列表
    getvipList: params => {
      return request ({
        url: '/admin/goods_vip/list',
        method: 'get',
        params,
      });
    },
    //vip详情
    getGoods_vipInfoDetil: params => {
      return request ({
        url: '/admin/goods_vip/info?id=' + params,
        method: 'get',
        data: params,
      });
    },
    //vip编辑
    getGoods_vipInfo: params => {
      return request ({
        url: '/admin/goods_vip/edit',
        method: 'post',
        data: params,
      });
    },
    //vip删除
    getGoods_vipDel: params => {
      return request ({
        url: '/admin/goods_vip/del?id=' + params,
        method: 'post',
      });
    },
    //充值模板添加
    getvipedit: params => {
      return request ({
        url: '/admin/goods_recharge/edit',
        method: 'post',
        params,
      });
    },
    //充值模版详情
    goods_rechargeinfo: params => {
      return request ({
        url: '/admin/goods_recharge/info',
        method: 'get',
        params
      });
    },
  };
}
